import request from '@/utils/request';
import { systemCohortVisualisationEndpoint } from '@/constants/urls';
import { cohortChart } from '../../visualisations/constants';

const cohortVisualisation = (variables, code, queryId, dictionaryCode, chartType) => (
  request({
    url: systemCohortVisualisationEndpoint(chartType, code),
    data: {
      ...variables,
      query_id: queryId,
      dictionary_code: dictionaryCode,
    },
    method: 'POST',
  })
);

const barChart = ({ xAxis }, requestCode, queryId, dictionaryCode) => (
  cohortVisualisation(
    { column: xAxis.value },
    requestCode,
    queryId,
    dictionaryCode,
    cohortChart.BAR,
  )
);

const stackedBarChart = ({ xAxis }, requestCode, queryId, dictionaryCode) => (
  cohortVisualisation(
    { column: xAxis.value },
    requestCode,
    queryId,
    dictionaryCode,
    cohortChart.STACKED_BAR,
  )
);

const boxPlot = ({ xAxis, yAxis }, requestCode, queryId, dictionaryCode) => (
  cohortVisualisation(
    { x_axis_column: xAxis.value, y_axis_column: yAxis.value },
    requestCode,
    queryId,
    dictionaryCode,
    cohortChart.BOX_PLOT,
  )
);

const histogram = ({ bins, yAxis }, requestCode, queryId, dictionaryCode) => (
  cohortVisualisation(
    { column: yAxis.value, bins: bins.value },
    requestCode,
    queryId,
    dictionaryCode,
    cohortChart.HISTOGRAM,
  )
);

const SystemCohortVisualisationService = {
  barChart,
  stackedBarChart,
  boxPlot,
  histogram,
};

export default SystemCohortVisualisationService;
